export default "__VITE_ASSET__C4so6wnC__ 600w";